import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_recursos } from "../../config/apiConfig";
import "../../pages/user/css/Empleo.css";

const RecursosSociales = ({ categoria }) => {
  const [recursos, setRecursos] = useState([]);

  useEffect(() => {
    const fetchRecursos = async () => {
      try {
        const res = await fetch(API_recursos);
        const data = await res.json();

        // Función para normalizar tildes y mayúsculas
        const normalize = (str) =>
          str
            ?.normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase();

        const categoriasValidas = ["vivienda", "prestaciones", "subvenciones", "social"];
        const hoy = new Date();

        const recursosFiltrados = data.filter((r) => {
          const categoriaRecurso = normalize(r.category);
          const esValida = categoriasValidas.includes(categoriaRecurso);
          if (!esValida) return false;

          if (normalize(categoria) === "destacadas") {
            return r.isFeatured;
          }

          if (normalize(categoria) === "todas") return true;

          return categoriaRecurso === normalize(categoria);
        });

        setRecursos(recursosFiltrados);
      } catch (error) {
        console.error("Error al cargar recursos sociales:", error);
      }
    };

    fetchRecursos();
  }, [categoria]);

  return (
    <div className="align-center w-100 noticias-container noticias">
      {recursos.map((recurso) => (
        <div key={recurso._id} className="noticia column social gap-5">
          <p className="etiqueta azul">#{recurso.category?.charAt(0).toUpperCase() + recurso.category?.slice(1).toLowerCase()}</p>
          <h2 className="mayusculas">{recurso.title}</h2>
          <Link className="azul" to={`/recurso-social/${recurso._id}`} aria-label="Más información sobre el recurso">
            Más información
          </Link>
        </div>
      ))}
    </div>
  );
};

export default RecursosSociales;
